import React from "react";
import Grid from "@mui/material/Grid2";
import PropTypes from "prop-types";


const styles = ({
  base: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "32px"
  },
});

export const ComparisonRightPanel = ({children}) => {
  return (
    <Grid container sx={styles.base}>
      {children}
    </Grid>
  );
};

ComparisonRightPanel.propTypes = {
  children: PropTypes.node,
};